import api from './api';

export interface WidgetFileInfo {
  id: string;
  assignmentId: string;
  widgetId: string;
  fileName: string;
  mimeType: string;
  fileSize: number | null;
  createdAt: string | null;
  deletedAt: string | null;
}

export interface WidgetFileListResponse {
  files: WidgetFileInfo[];
}

/**
 * Upload a file to widget storage.
 */
export async function uploadWidgetFile(
  assignmentId: string,
  widgetId: string,
  file: File,
): Promise<WidgetFileInfo> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post<WidgetFileInfo>(
    `/storage/${assignmentId}/${widgetId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
}

/**
 * List all active (non-deleted) files for a widget.
 */
export async function listWidgetFiles(
  assignmentId: string,
  widgetId: string,
): Promise<WidgetFileInfo[]> {
  const response = await api.get<WidgetFileListResponse>(
    `/storage/${assignmentId}/${widgetId}`,
  );
  return response.data.files;
}

/**
 * Get the download URL for a file (returns blob URL).
 */
export async function downloadWidgetFile(
  assignmentId: string,
  widgetId: string,
  fileId: string,
): Promise<string> {
  const response = await api.get(
    `/storage/${assignmentId}/${widgetId}/${fileId}`,
    { responseType: 'blob' },
  );
  return URL.createObjectURL(response.data);
}

/**
 * Soft-delete a file.
 */
export async function deleteWidgetFile(
  assignmentId: string,
  widgetId: string,
  fileId: string,
): Promise<void> {
  await api.delete(`/storage/${assignmentId}/${widgetId}/${fileId}`);
}
